/* template */
<template minapp="mpx" xlang="wxml"><es-drawer-bottom :title="(title)" :show="(show)" showDefaultNav @close="closePriceDetail" :customStyle="(curCustomStyle)" class="main"><price-detail-card :hasBottomBar="(hasBottomBar)" :priceDetail="(priceDetail)" :priceDetailCardTip="(priceDetailCardTip)" @close="closePriceDetail" :studentLength="(studentLength)"/></es-drawer-bottom></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m853d8b3a"}'>
  @import '~@/mixins/stylus/color.styl'

  .main
    /deep/ .es-navbar
      background-color $trian-color-background
    /deep/ .drawer-container
      overflow auto
  .rich-text-bold
    font-family PingFangSC-Semibold
    font-size 18px
    letter-spacing 0
    text-align right
    display flex
    align-items center
    color $train-color-theme-blue
    font-weight normal
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m853d8b3a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex853d8b3a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex853d8b3a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m853d8b3a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index853d8b3a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-drawer-bottom':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex")),'price-detail-card':getComponent(require("../price-detail-card/index.mpx?isComponent&outputPath=components%2Findex71c8fd7c%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
